<template>
<button @click="$emit('clicked');" type="button" class="btn btn-primary custom-btn" style="white-space: nowrap;">
    <template v-if="processing">
    <span class="spinner-grow spinner-grow-sm"></span>
    Loading..
    </template>
    <template v-else><span v-html="text"></span></template>
</button>
</template>

<script>
    export default {
        props:['text','processing'],
        data(){
            return {
            }
        },
    }
</script>
